import businessClient from 'src/services/clients/business'
import { IMeta, IRole } from 'src/common/interfaces/index.js'

const IResponse = { meta: IMeta, data: { list: [IRole] } }

export const role = {
  /**
   * @param {{ filter: object }} object
   * @return {Promise<IResponse>}
   */
  getRoles(filter = {}) {
    return businessClient().post('staff/roles/portal/list', { filter })
  },
}
